/* eslint-disable max-lines */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withStyles } from 'tss-react/mui';
import { green } from '@mui/material/colors';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar';
import {
  ArrowDropDown,
  HighlightOff,
  CheckCircle,
  Visibility,
  VisibilityOff,
} from '@mui/icons-material';
import { attachFile } from '@lba-dev/package.local-globals/utils';
import {
  MAILS_RECOUVRMENT,
  MAIL_TEXT,
  MAILS_LITIGE,
  DEMANDE_SAV,
  MISE_EN_DEMEURE,
  REMISE_COMMERCIALE,
  KEYS_CONCLUSIONS,
  NAMES_CONCLUSIONS,
  ENVOI_EN_LITIGE,
  ENVOI_EN_RECOUVREMENT,
  ENVOI_EN_PJ,
  COURRIER_DERNIER_AVIS_AVANT_POURSUITE,
  MAIL_SIGNIFICATION_IP_HUISSIER,
} from '@lba-dev/package.local-globals/rConclusions';
import {
  R_DATAS,
  R_EC,
  R_ECR,
  R_RES,
  R_PRE_RES,
} from '@lba-dev/package.local-globals/rStatus';
import {
  CauseData as causeDataLitige,
  CatData as categorieDataLitige,
} from '@lba-dev/package.local-globals/lCauses';
import {
  data as causeDataRec,
  CatData as categorieDataRecouvrement,
} from '@lba-dev/package.local-globals/rCauses';
import {
  CatData as proceduresJudiciairesData,
} from '@lba-dev/package.local-globals/pjCauses';
import { permit } from '@lba-dev/package.local-globals/restrictions';
import { CHIEF } from '@lba-dev/package.local-globals/permissions';
import { C_COMPTA } from '@lba-dev/package.local-globals/commentTypes';
import { E_DEC } from '@lba-dev/package.local-globals/encaissementType';
import { RT_CLI, RT_PJ } from '@lba-dev/package.local-globals/rTypes';
import Chip from '@mui/material/Chip';
import { fromJS, List } from 'immutable';
import {
  getStatusRecouvrement,
  R_CLI,
  L_CLI,
  R_PJ,
  R_BAD_REVIEW
} from '@lba-dev/package.local-globals/recStatus';

import Causes from './Causes';
import SubStatusDevis from './subStatusDevis';
import Resulo from './ResoluComponent';
import CustomSwitch from '../../CustomInputs/CustomSwitch';
import DialogConcl from './DialogConcl';
import ExpandedCommentaires from './Historiques';
import PriseDeContactFooter from './PriseDeContactFooter';
import Decaissement from './ExpandedDecaissement';
import { addEncaissement } from '../../../actions/compta';
import { postComment } from '../../../actions/inter';
import { checkDecaissement } from '../../Reglement/functions';
import api from '../../../api';
import notifSystem from '../../../notifSystem';
import { deleteCaissement } from '../../../actions/encaissement';
import PriseEnChargeInput from './PriseEnChargeInput';


const styles = (theme) => ({
  center: {
    textAlign: 'center',
  },
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
    },
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    margin: theme.spacing(1),
  },
  buttons: {
    padding: `${theme.spacing(2)} 0`,
  },
  button: {
    margin: `${theme.spacing(1)} 0`,
  },
  chip: {
    margin: theme.spacing(1),
  },
  margin: {
    margin: theme.spacing(1),
  },
});

const mapStateToProps = ({ connectedUser, users }) => ({
  user: connectedUser,
  users,
});

const GenConclusions = React.memo(({
  negociating,
  classes,
  setConclusion,
  type,
}) =>
  [...(type === R_PJ ?
    (KEYS_CONCLUSIONS.slice(0, 4)) :
    KEYS_CONCLUSIONS)
  ].map((e, id) => {
    const negociatingId = id === 5;
    return (
      <Grid item xs className={classes.center} key={e}>
        <Button
          variant="outlined"
          color="secondary"
          style={{
            color: negociatingId && negociating && green[500],
            borderColor: negociatingId && negociating && green[500],
            padding: negociatingId ? 10 : 8,
          }}
          onClick={() => setConclusion(id)}
        >
          {NAMES_CONCLUSIONS[id]}
          {negociatingId && negociating && (
            <CheckCircle style={{ color: green[500] }} />
          )}
          {negociatingId && !negociating && <HighlightOff />}
          {id !== 5 && <ArrowDropDown />}
        </Button>
      </Grid>
    );
  })
);
class PriseDeContactDialog extends Component {
  state = {
    element: this.props.defaultText,
    recouvrement: this.props.defaultText.recouvrement,
    loading: false,
    conclusionOpen: false,
    historiqueOpen: false,
    selected: -1,
    decaissements: new List(),
  };

  componentDidMount() {
    this.getEncaissements();
  }

  getEncaissements = async () => {
    const { element: { id }, recouvrement } = this.state;

    const content = await api.encaissements
      .getAll({
        query: JSON.stringify({
          $or: [{ id }, { multis: { $elemMatch: { id } } }],
          type: E_DEC,
        }),
      })
      .then((e) => e.body().map((e) => e.data()));
    this.setState({
      decaissements: new List(content),
      recouvrement: {
        ...recouvrement,
        conclusions: []
      },
    });
  };

  cancel = () => {
    if (typeof this.props.callback === 'function') {
      this.props.callback(null);
    }
  };

  onValidate = () => {
    const { element, mail, decaissements, recouvrement } = this.state;
    const { user, callback } = this.props;
    if (typeof callback !== 'function') {
      return;
    }
    if (decaissements.size && !checkDecaissement(decaissements)) {
      notifSystem.error('Erreur', 'Les décaissements sont incorrects');
      return;
    }
    const rec = { ...recouvrement };
    const type = getStatusRecouvrement(rec);
    if (
      (rec.isLitige && !rec.categorie) ||
      !rec.commentaire ||
      !rec.status ||
      (!rec.cause && type === RT_PJ)
    ) {
      notifSystem.error(
        'Pour valider votre prise de contact',
        'Merci de mettre un statut, un commentaire, une cause et une catégorie'
      );
      return;
    }
    if ([R_RES, R_PRE_RES].includes(rec.status) &&
      typeof rec.montantEncaisse !== 'number') {
      notifSystem.error(
        'Pour valider votre prise de contact',
        'Merci de saisir le montant encaissé'
      );
      return;
    }
    if ([R_RES, R_PRE_RES].includes(rec.status) && !rec.resuloStatus) {
      notifSystem.error(
        'Pour valider votre prise de contact',
        'Merci de selectionner une sous-catégorie pour le statut résolu.'
      );
      return;
    }
    if (
      !rec.montantEmisDemeure &&
      rec.conclusions.includes(COURRIER_DERNIER_AVIS_AVANT_POURSUITE)
    ) {
      notifSystem.error(
        'Pour valider le dernier avis avant poursuite',
        'Veuillez créer une mise en demeure tout d\'abord.'
      );
      return;
    }
    if (
      rec.conclusions.includes([...MAILS_LITIGE, ...MAILS_RECOUVRMENT]) &&
      (!mail.text ||
        ((/<Modifiable>/)).test(mail.text) ||
        !mail.desMail ||
        !mail.title)
    ) {
      notifSystem.error(
        'Erreur mail',
        'Veuillez vérifier le corps du mail,' +
          ' le destinataire, le titre et <Modifiable>'
      );
      return;
    }
    if (
      rec.conclusions.includes(ENVOI_EN_RECOUVREMENT) ||
      rec.conclusions.includes(ENVOI_EN_LITIGE) ||
      rec.conclusions.includes(ENVOI_EN_PJ)
    ) {
      rec.isPris = false;
      rec.isLitige = rec.conclusions.includes(ENVOI_EN_LITIGE);
      rec.type = rec.conclusions.includes(ENVOI_EN_PJ) ? RT_PJ : RT_CLI;
      rec.categorie = 0;
      rec.status = 0;
      rec.cause = 0;
      rec.conclusions = [];
    }
    rec.historique = (rec.historique || []).concat({
      userId: user._id,
      comments: rec.commentaire,
      date: new Date(),
      conclusions: rec.conclusions,
    });
    delete rec.commentaire;
    rec.priseDeContact = new Date();
    element.recouvrement = rec;
    callback(element, mail);
    if (decaissements.size) {
      addEncaissement(decaissements.toJS(), user._id, fromJS(element));
      if (element.recouvrement.commentaireCompta) {
        postComment(element._id, element.recouvrement.commentaireCompta, {
          type: C_COMPTA,
        });
      }
    }

    this.setState({ element, recouvrement: rec });
  };

  addFile = (e) => {
    const { mail } = this.state;

    attachFile(e.target.files[0]).then((attachment) =>
      this.setState({
        mail: {
          ...mail,
          attachements: mail.attachements.concat(attachment),
        },
      })
    ).catch(e =>
      notifSystem.error('Erreur',
        e.message || 'Une erreur est survenue'));
  };

  reset = () => {
    const { recouvrement } = this.state;
    if (recouvrement) {
      return this.setState({
        recouvrement: {
          ...recouvrement,
          commentaire: '',
          negociating: false,
          conclusions: [],
          status: 0,
          ...(recouvrement.isLitige ? { dissatisfactionDetected: true } : {}),
        },
        selected: -1,
        mail: {},
      });
    }
    return this.setState({ selected: -1 });
  };

  handleCheckboxes = (id) => {
    const { user } = this.props;
    const fId = Number(id[0]);
    const { mail, element } = this.state;
    const recouvrement = { ...this.state.recouvrement };
    const ret = [...recouvrement.conclusions];
    const index = ret.indexOf(fId);
    const dataArray = [
      ...(recouvrement.isLitige ? MAILS_LITIGE : MAILS_RECOUVRMENT),
    ];
    if (index === -1) {
      ret.push(fId);
    } else {
      ret.splice(index, 1);
    }
    recouvrement.conclusions = ret;
    if (recouvrement.conclusions.includes(REMISE_COMMERCIALE)) {
      recouvrement.status = R_ECR;
    } else if (
      recouvrement.conclusions.includes(DEMANDE_SAV) ||
      recouvrement.conclusions.includes(MISE_EN_DEMEURE)
    ) {
      recouvrement.status = R_EC;
    }
    const hasMailInCon = ret.find((e) => dataArray.includes(e));
    let findMail = dataArray.includes(fId);
    if (findMail && hasMailInCon) {
      findMail = MAIL_TEXT.find((e) => e._id === fId);
      if (findMail && mail && mail.text) {
        return notifSystem.error(
          'Erreur',
          'Merci de sélectionner un seul mail'
        );
      }
      return this.setState({
        mail: findMail
          ? {
            attachements: [],
            text: findMail.mail(element, user),
            name: findMail.name,
            title: findMail.title || `Intervention n°${element.id}`,
            desMail: recouvrement.conclusions.includes(
              MAIL_SIGNIFICATION_IP_HUISSIER
            )
              ? ''
              : `${
                (Object.keys(element.billing || {}).length
                  ? element.billing
                  : element.client
                ).email1 || ''
              }`,
          }
          : mail,
        recouvrement,
      });
    }
    return this.setState({
      recouvrement,
      mail: hasMailInCon ? mail : {},
    });
  };

  handelChange = (name, v) => {
    this.setState({
      [name]: v,
    });
  };

  setData = (path, value) => {
    const recouvrement = fromJS(this.state.recouvrement);
    this.setState({
      recouvrement: recouvrement.setIn(path, value).toJS(),
    });
  };

  setInterData = (path, value) => {
    const element = fromJS(this.state.element);
    this.setState({
      element: element.setIn(path, value).toJS(),
    });
  };

  setConclusion = (id) => {
    if (id === 5) {
      const recouvrement = { ...this.state.element.recouvrement };
      this.setState({
        recouvrement: {
          ...recouvrement,
          negociating: !recouvrement.negociating,
          status: R_EC,
        },
        selected: -1,
        conclusionOpen: false,
      });
    } else {
      this.setState({
        conclusionOpen: true,
        selected: id,
      });
    }
  };

  deleteComment = async (id) => {
    try {
      const recouvrement = this.state.element.recouvrement;
      if (id > -1) {
        recouvrement.historique.splice(id, 1);
      }
      this.setState({ recouvrement });
      const { _id, ...data } = recouvrement;
      await api.recouvrements.patch(_id, { recouvrement: data });
      return notifSystem.success(
        'Message',
        'Le commentaire a bien été supprimé'
      );
    } catch (error) {
      return notifSystem.error('Erreur',
        'Le commentaire n\'a pas été supprimé');
    }
  };

  handleChipDelete = (index) => {
    const mail = Object.assign({}, this.state.mail);
    mail.attachements.splice(index, 1);
    const ret = mail.attachements.slice(0);
    this.setState({
      mail: {
        ...mail,
        attachements: ret,
      },
    });
  };

  render() {
    const { open, classes, user, users } = this.props;
    const {
      element: { commissionValide, id, encaissement, decaissement },
      recouvrement,
      loading,
      selected,
      conclusionOpen = false,
      mail = {},
      decaissements,
      commentaireCompta,
      historiqueOpen,
    } = this.state;
    const type = getStatusRecouvrement(recouvrement);
    const [causeDataToFetch, categorieDataToFetch, title] = {
      [L_CLI]: [causeDataLitige, categorieDataLitige, 'litige'],
      [R_CLI]: [causeDataRec, categorieDataRecouvrement, 'recouvrement'],
      [R_PJ]: [[], proceduresJudiciairesData, 'procédure judiciaire'],
      [R_BAD_REVIEW]: [causeDataLitige, categorieDataLitige, 'avis négatif'],
    }[type];
    return (
      <Dialog open={open} fullWidth maxWidth={'lg'}>
        {!conclusionOpen ? (
          [
            <DialogTitle key="title">
              <Grid container spacing={2} justifyContent="space-between">
                <Grid item xs={6}>
                  <Typography variant="h6">Prise de contact</Typography>
                </Grid>
                <Grid item xs={4}>
                  <PriseEnChargeInput
                    classes={classes}
                    label={
                      recouvrement.isLitige
                        ? 'Montant du litige'
                        : 'Montant du recouvrement'
                    }
                    path={['priseEnCharge', 'montant']}
                    priseEnChargeMontant={
                      (recouvrement.priseEnCharge &&
                        recouvrement.priseEnCharge.montant) ||
                      0
                    }
                    setData={this.setData}
                    disabled={!permit(user, { auth: CHIEF })}
                  />
                </Grid>
                {recouvrement.isLitige && (
                  <Grid item xs={2}>
                    <Chip
                      avatar={
                        <Avatar>
                          {recouvrement.dissatisfactionDetected ? (
                            <Visibility />
                          ) : (
                            <VisibilityOff />
                          )}
                        </Avatar>
                      }
                      color="primary"
                      label={
                        recouvrement.dissatisfactionDetected
                          ? 'insatisfaction: detectée'
                          : 'insatisfaction: non detectée'
                      }
                      className={classes.chip}
                      onClick={() =>
                        this.setData(
                          ['dissatisfactionDetected'],
                          !recouvrement.dissatisfactionDetected
                        )
                      }
                    />
                  </Grid>
                )}
              </Grid>
            </DialogTitle>,
            <DialogContent key="content">
              {type !== R_PJ &&
                <>
                  <Button
                    variant="outlined"
                    color="primary"
                    fullWidth
                    className={classes.button}
                    children={'Sous-status devis'}
                  />
                  <Grid container justifyContent="space-around" spacing={2}>
                    <SubStatusDevis
                      handleChange={(e) =>
                        this.setData(['subStatusDevis'], Number(e.target.value))
                      }
                      value={recouvrement.subStatusDevis}
                    />
                  </Grid>
                </>
              }
              {
                !!causeDataToFetch.length && <>
                  <Button
                    variant="outlined"
                    color="secondary"
                    fullWidth
                    className={classes.button}
                    children={`Cause du ${title}`}
                  />
                  <Causes
                    isPris={recouvrement.isPris}
                    fetchData={causeDataToFetch}
                    handleChange={(e) =>
                      this.setData(['cause'], Number(e.target.value))
                    }
                    value={recouvrement.cause}
                  />
                </>
              }
              <Button
                variant="outlined"
                color="primary"
                fullWidth
                className={classes.button}
                children={`Catégorie : ${title}`}
              />
              <Causes
                isPris={recouvrement.isPris}
                fetchData={categorieDataToFetch.filter(
                  (e) => !e.for || e.for?.includes(recouvrement.cause)
                )}
                handleChange={(e) =>
                  this.setData(['categorie'], Number(e.target.value))
                }
                value={recouvrement.categorie}
              />
              <>
                <Button
                  variant="outlined"
                  color="primary"
                  fullWidth
                  className={classes.button}
                  children={'Conclusion'}
                />
                <Grid
                  container
                  spacing={3}
                  justifyContent={'center'}
                  className={classes.buttons}
                  children={
                    <GenConclusions
                      setConclusion={this.setConclusion}
                      classes={classes}
                      negociating={recouvrement.negociating}
                      type={type}
                    />
                  }
                />
              </>
              <Button
                variant="outlined"
                color="primary"
                fullWidth
                className={classes.button}
                children={`Statut du ${title}`}
              />
              <Grid>
                <Causes
                  isPris={recouvrement.isPris}
                  fetchData={R_DATAS.filter((e) => {
                    const hasPermission = permit(user, {
                      key: 'displayStatusPriseDeContactDialog',
                      auth: e.perm,
                    });
                    if (type === R_BAD_REVIEW) {
                      return hasPermission && e.mauvaisAlias;
                    }
                    return hasPermission;
                  })}
                  handleChange={(e) =>
                    this.setData(['status'], Number(e.target.value))
                  }
                  value={recouvrement.status}
                  useMauvaisAlias={type === R_BAD_REVIEW}
                />
              </Grid>
              <Grid container spacing={3} justifyContent={'center'}>
                {[R_RES, R_PRE_RES].includes(recouvrement.status) && (
                  <Resulo
                    setData={this.setData}
                    recouvrement={recouvrement}
                    encaissement={encaissement}
                    decaissement={decaissement}
                  />
                )}
                {recouvrement.status === R_RES && (
                  <CustomSwitch
                    key="2"
                    label="Commission intervention"
                    checked={commissionValide || false}
                    path={['commissionValide']}
                    setData={this.setInterData}
                  />
                )}
              </Grid>
              <Paper className={classes.root} elevation={1}>
                <TextField
                  fullWidth
                  texttransform="none"
                  rows={4}
                  multiline
                  label="Commentaire..."
                  value={recouvrement.commentaire || ''}
                  onChange={(e) =>
                    this.setData(['commentaire'], e.target.value)
                  }
                />
              </Paper>
              <Decaissement
                expansionTitle="Décaissement"
                decaissements={decaissements}
                classes={classes}
                data={{ id: this.state.element.id }}
                setData={(p, v) => this.handelChange('decaissements', v)}
                deleteCaissement={deleteCaissement}
                commentValue={commentaireCompta}
              />
              <ExpandedCommentaires
                expansionTitle={`OS ${id}`}
                deleteComment={
                  permit(user, { key: 'accessComRecouvrement' }) &&
                  this.deleteComment
                }
                key="history"
                inters={[fromJS({ ...this.state.element, checked: true })]}
                users={users}
                classes={classes}
              />
            </DialogContent>,
            !!(mail.attachements || []).length && (
              <DialogContent key="files">
                {Object.values(mail.attachements).map((element, index) => (
                  <Chip
                    key={`${element.name}PriseDeContactDialog`}
                    label={element.name}
                    onDelete={() => this.handleChipDelete(index)}
                  />
                ))}
              </DialogContent>
            ),
            <PriseDeContactFooter
              key="footer"
              attachements={!!mail.attachements}
              addFile={this.addFile}
              send={this.onValidate}
              cancel={this.cancel}
              loading={loading}
              reset={this.reset}
              historique={() =>
                this.handelChange('historiqueOpen', !historiqueOpen)
              }
            />,
          ]
        ) : (
          <DialogConcl
            mail={mail}
            facture
            setMail={(path, value) =>
              this.handelChange('mail', { ...mail, [path]: value })
            }
            recouvrement={recouvrement}
            handleCheckboxes={this.handleCheckboxes}
            selected={selected}
            setData={this.setData}
            setConclusionDialog={() =>
              this.handelChange('conclusionOpen', !conclusionOpen)
            }
          />
        )}
      </Dialog>
    );
  }
}
PriseDeContactDialog.defaultProps = {
  validateText: 'Valider',
  cancelText: 'Annuler',
  maxWidth: 'sm',
  fullWidth: false,
};

export default connect(mapStateToProps)(
  withStyles(PriseDeContactDialog, styles));
